<template>
  <div class="toolbar halftone clearfix">

    <!-- Selected Options (Info) on the left -->
    <div class="info-panel">
      <button class="selected-tool"><span class="icon-{{ state.tool }}"></span></button>
      <button class="selected-color" data-cmd="showPalette" data-arg="colors">
        <div v-bind:style="{ 'background-color': state.color }"></div>
      </button>
      <button class="selected-brush" data-cmd="showPalette" data-arg="brushes">
        <div class="brush-icon" v-bind:style="{ backgroundPosition: state.selectedBrush.backgroundPosition }"></div>
      </button>
      <button class="selected-line-width" data-cmd="showPalette" data-arg="line-widths">
        <div class="line-icon line-icon-{{ Math.floor(state.lineWidth) }}"></div>
      </button>
    </div>

    <!--<div class="colors-panel">-->
      <!---->
    <!--</div>-->
    <!-- Long row of available tools on the right -->
    <div class="tools" v-on:click="selectTool">
      <span v-for="tool in state.TOOLS">
        <button id="btn-{{ tool }}" v-bind:class="{ selected: state.tool==tool, disabled: !state.isToolEnabled(tool) }">
          <span class="icon-{{ tool }}"></span>
        </button>
      </span>
    </div>

  </div>
</template>

<style lang="scss" scoped>

  .toolbar {
    height: 85px;
    width: 100%;
    position: relative;

    .info-panel {
      width: 2*41px;
      margin: 2px 10px;

      button {
        padding: 0;
        line-height: 0;
      }
    }

    .tools {
      width: 9*41px;
      position: absolute;
      right: 10px;
    }

    button {
      width: 40px;
      height: 40px;
      display: block;
      float: left;
      margin: -1px -1px 0 0;
      overflow: hidden;
    }

    .selected-color {
      div {
        width: 30px;
        height: 30px;
        margin: 5px;
        border: 1px solid #000;
      }
    }

    .selected-brush {
      .brush-icon {
        margin: 5px 10px;
      }
    }
  }

</style>

<script>

  import state from '../data/state';
  import filterImage from '../util/filterImage';

  function clear(ctx) {
    ctx.clearRect(0,0,ctx.canvas.width, ctx.canvas.height);
  }

  function drawCircle(ctx, x, y, r) {
    r = Math.abs(r);
    ctx.save();
    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI*2);
    ctx.restore();
  }

  export default{
    data(){
      return {
        state
      }
    },
    methods: {

      selectTool(event) {
        // get tool name from target element (button)
        const tool = event.target.id.split('-').pop();
        // update state
        state.setTool(tool);

        //this.updateBrushDisplay();
      },

//      updateBrushDisplay() {
//
//        if(state.lineWidth==this.previousLineWidth) {
//          return;
//        }
//
//        clear(this.brushCtx);
//        this.brushCtx.fillStyle = '#000000';
//        this.brushCtx.beginPath();
//        drawCircle(this.brushCtx, 16, 16, state.lineWidth / 2);
//        this.brushCtx.fill();
//        filterImage(this.brushCtx);
//
//        this.previousLineWidth = state.lineWidth;
//      }
    },

    ready() {
      //this.brushCanvas = $('.selected-brush canvas')[0];
      //this.lineCanvas = $('.selected-line-width canvas')[0];
      //this.brushCtx = this.brushCanvas.getContext('2d');
      //this.lineCtx = this.lineCanvas.getContext('2d');

      clearInterval(this.brushUpdateInterval);
      //this.brushUpdateInterval = setInterval(this.updateBrushDisplay.bind(this), 500);
    },

    beforeDestroy() {
      clearInterval(this.brushUpdateInterval);
    }

  }
</script>



// WEBPACK FOOTER //
// ToolBar.vue?36d73b37